var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 18,
    fill: "url(#pattern0_3137_823)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3137_823",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3137_823",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3137_823",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAB2AAAAdgB+lymcgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAASRSURBVHic7ZtLjBRFGMd/M7OLBJHHiYswyLosLI/EiyEkhKM3w0lwiYoJwcgRwXAwcoADwRAS5YgQxEhMSEyMnCAhvBJlOcljXN7PyGERVjC47i7j4auyatzudaqmurrB/SWdrZmp+r5/VVdVV31dC+P8vynl6LsKLFTpc8CtHLVEpRs4DtT/dR0D5ueoKwqLgIeMrry+HgALclMXgdOYyp4BPgTWA73W9ydyU5cxczCV/BFos35rRxpE/z47lqhyLEfAPCv9NTBsfR5S3yXlfW74AHOHbwD9SMWHVPqG9fu6XBRmQAVYBZwlfeJLu3qBlcTtpUFZCVwiuXJ3kTF/GPhBpe+m5O0D3oqsvSWmIOPZrsRfwEFgLdAxRtkOleegKmPb+ErZLjTzgGsY0X8CXwCzPGxVgd3AoGXvKtAVRGkGdNLYjWvAawHsLgB+tuzeo4BPidnAHYzIb4FJAe1PUja1/Vv49apMKNO4tj9E4yInFBXgG8vPKfVd7nyMEXUEWdVlRTtw1PK3MUNfTfEKMtHpjczLEXzOVL7qwBMiLpuT+BxzN9ZE9Pu+5XdXRL8NTAceKRHXiDseK8AV5ft3YJqvoVaWmWuAySq9CxhpwZYrI8j6AuAl4N2Ivv/hGHIHhshnhTZV+a4jE2NUJmAmv59iO7fQgZQneD59fIdAN/CCSp/0tBGC4+rvRDxDab4NYDs762kjBL1WemFqrjFopQdoLnjaCEHNSntFlFvtAcPInj8v+jChte6xMoZGBzp+iek0hT5M4MQZnx4wEYnwAlz0cRoYraED0eaETwN0YVZ9RWqACjDXtbBPA9hjrZaaKx72TXCeB1ptgDyfAJrcGuApnhNPYGqYfUiUJ0ENmXUvx3DWJHpn6DwnufaACcCrKl2ECVCjtXRiluhN4doAczHxviI2QBvmBjWFawPYY6yIDQCOm6LnsQGcJkLfBnhKMZbBmouIJsj4mM15TAywaFxHtJ1zKeTSA6ZhlppF6v4avSjrwiFI6tIAPZiwU55RoDROq7/twNuhjb+OCYEPIi8nikYV80r9EaI5CO8BjzEvIraGMpwB2zA6HyPavakAeyyD+pBCIV5IptCGaLQ178FT837LyBCwiXyP1jZLCdFqnzDZ52pkqVX4V/X5WWMpol3XY4lL4Z1WwWXBpcVjOaYeO5IypD0GZ1jpM4FFxcR+bzAjKUNaA1y10m8EkxMfW/v1pAxpk5o+mFRGXj/vxC/+p88HJzrPuHw3sAF5cTsCLMZxBbsD99OdRb22u1RcUwI2M/b5/qJfD5EzTKmP72ae6y8iQ6LaRF6bKvCZSn+HnP50oQdYodIfAbcdy99ENkh/OJYLRjvwGyZY6bKIKmOCr/1kc+wuCvsw3bHHodw7VrkvM9AVjU7MknQA+Z+h/2KxyltHdp5OQc4isgVzNweA1SQPhzJy5wes/J9kLS7G5qYEHEAqrqkB32PiivOBN2k8BH0A2c7WI2jMnBLwKaP/ByDpGkTu/LOw83SmE9gL3Gd0xfuRCS/qmM+rlduQ7q7PFt9BhsNwaolxxsmEvwEKS6y5O8P0nQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationnew);
export default __webpack_public_path__ + "static/media/notificationnew.a04e6392f9e52bfac3c947896ff663ca.svg";
export { ForwardRef as ReactComponent };